/**
 * @generated SignedSource<<850906b88a846d071c58361c11fee49d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserInfoInput = {
  bio: string;
  username: string;
};
export type useUpdateUserMutation$variables = {
  input: UpdateUserInfoInput;
};
export type useUpdateUserMutation$data = {
  readonly updateUserInfo: {
    readonly __typename: "ErrInvalidInput";
    readonly __typename: "ErrInvalidInput";
  } | {
    readonly __typename: "ErrNotAuthorized";
    readonly __typename: "ErrNotAuthorized";
  } | {
    readonly __typename: "ErrUsernameNotAvailable";
    readonly __typename: "ErrUsernameNotAvailable";
  } | {
    readonly __typename: "UpdateUserInfoPayload";
    readonly viewer: {
      readonly user: {
        readonly bio: string | null;
        readonly id: string;
        readonly username: string | null;
      } | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useUpdateUserMutation = {
  response: useUpdateUserMutation$data;
  variables: useUpdateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "updateUserInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bio",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "UpdateUserInfoPayload",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e07c58519190ce9c61c51734cb6ae270",
    "id": null,
    "metadata": {},
    "name": "useUpdateUserMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateUserMutation(\n  $input: UpdateUserInfoInput!\n) {\n  updateUserInfo(input: $input) {\n    __typename\n    ... on UpdateUserInfoPayload {\n      viewer {\n        user {\n          id\n          username\n          bio\n        }\n      }\n    }\n    ... on ErrInvalidInput {\n      __typename\n    }\n    ... on ErrNotAuthorized {\n      __typename\n    }\n    ... on ErrUsernameNotAvailable {\n      __typename\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed7dff867248feea152e2ecfeb40ef08";

export default node;
